import React from 'react';
import { useTranslation } from 'react-i18next';
import Grid, { itemText, itemHtml } from '@/components/molecules/section/Grid';
import { useClientStats } from '@/hooks/client';
import Loading from '@/components/modals/Loading';
import Error from '@/components/modals/Error';
import { ClientStatsModal } from '@/types/modal';
import { StandardModal } from '@/components/molecules/common/Modal';
import styles from './Modal.module.scss';
import sectionStyles from '../atoms/Section.module.scss';
import { Box } from '@mui/material';
type Props = {
  modal: ClientStatsModal;
};

const ClientStats: React.FC<Props> = ({ modal }) => {
  const { t } = useTranslation();
  const stats = useClientStats(modal.clientId);

  if (stats.kind === 'Called') {
    return <Loading modal={{ kind: 'Loading', title: t('client.stats.title'), onClose: modal.onClose }} />;
  }

  if (stats.kind === 'Error') {
    return (
      <Error modal={{ kind: 'Error', title: t('client.stats.title'), error: stats.error, onClose: modal.onClose }} />
    );
  }

  if (stats.kind !== 'Loaded' || !stats.data) {
    return null;
  }

  const items = [
    itemText(t('client.stats.total_sold'), stats.data.totalSold),
    itemText(t('client.stats.total_shipped'), stats.data.totalShipped),
    itemText(t('client.stats.total_cancelled'), stats.data.totalCancelled),
    itemHtml(
      t('client.stats.usually_ship_in'),
      <div className={sectionStyles.text}>
        {stats?.data?.message
          ? stats.data.message
              .split(/(\*\*.*?\*\*)/g)
              .map((part, index) =>
                part.startsWith('**') && part.endsWith('**') ? <strong key={index}>{part.slice(2, -2)}</strong> : part,
              )
          : '-'}
      </div>,
    ),
  ];

  const body = (
    <Box sx={{ minWidth: '50rem' }}>
      <p>{t('client.stats.description')}</p>
      <div className={styles.itemProofOfPaymentTable}>
        <Grid
          column={4}
          items={items}
        />
      </div>
    </Box>
  );

  return (
    <StandardModal
      title={t('client.stats.title')}
      onClose={modal.onClose}
      onSubmit={modal.onClose}
      submittable={true}
      body={body}
      modalName="client_stats"
      ignoreSubmitLabel={true}
      closeLabel={t('common.close')}
    />
  );
};

export default ClientStats;
